const constants = {
    SET_SECTION_SUBTITLE: 'SET_SECTION_SUBTITLE',
    SET_SECTION_LOGO: 'SET_SECTION_LOGO',
    GET_COLLECTION: 'GET_COLLECTION',
    GET_COVER_COLLECTIONS: 'GET_COVER_COLLECTIONS',
    GET_COLLECTIONS: 'GET_COLLECTIONS'
};

export default constants;



// WEBPACK FOOTER //
// ./src/constants/CollectionsConstants.js